const data = [
    {
        id : 1,
        link: '#',
        title: 'Home'
    },
    {
        id : 2,
        link: '#About',
        title: 'About'
    },
    {
        id : 3,
        link: '#Portfolio',
        title: 'Projects'
    },
    {
        id : 4,
        link: '#Services',
        title: 'Services'
    },
    {
        id : 5,
        link: '#Contact',
        title: 'Contact'
    }
]

export default data;